module.exports = __webpack_public_path__ + "static/media/Molly Anderson Headshot.36b2623f.jpeg";